(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory();
	else if(typeof define === 'function' && define.amd)
		define([], factory);
	else if(typeof exports === 'object')
		exports["Smiley"] = factory();
	else
		root["Smiley"] = factory();
})(this, function() {
return /******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};

/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {

/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId])
/******/ 			return installedModules[moduleId].exports;

/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			exports: {},
/******/ 			id: moduleId,
/******/ 			loaded: false
/******/ 		};

/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);

/******/ 		// Flag the module as loaded
/******/ 		module.loaded = true;

/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}


/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;

/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;

/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "";

/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(0);
/******/ })
/************************************************************************/
/******/ ([
/* 0 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';

	var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }(); /**
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                          * Description: 表情工具组件，支持旺旺、小蜜和万象
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                          *
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                          * Author: linghao.llh@alibaba-inc.com
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                          * Date: 2016/12/01
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                          *
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                          */

	var _map = __webpack_require__(1);

	var CDN_HOST = '//g.alicdn.com/crm/static/0.5.1/';

	var GIF_SUPPORT_LIST = ['xm'];

	var LARGE_SUPPORT_LIST = ['xm', 'wx'];

	var GIF_EXT = '.gif';

	var EXT_MAP = {
	  ww: '.png',
	  xm: '.png',
	  wx: '.png'
	};

	var SMILEY_MAP = {
	  ww: toMap(_map.WW_SMILEY.concat(_map.WW_BLACKLIST), 'ww'),
	  xm: toMap(_map.XM_SMILEY.concat(_map.XM_BLACKLIST), 'xm'),
	  wx: toMap(_map.WX_SMILEY, 'wx')
	};

	/**
	 * 将上面的数组转换为对象，key 为表情文字，value 为图片地址
	 * 例如：
	 * {
	 *   '微笑': '//g.alicdn.com/crm/static/0.4.2/ww/001.png'
	 *   ...
	 * }
	 *
	 * @param arr {Array} map.js 中的数组
	 * @param prefix {String} 类型，'ww' | 'xm' | 'wx'
	 *
	 * @return {Object}
	 */
	function toMap(arr, prefix) {
	  return arr.reduce(function (map, item) {
	    var _item = _slicedToArray(item, 2),
	        code = _item[0],
	        word = _item[1];

	    map[word] = CDN_HOST + prefix + '/' + code + EXT_MAP[prefix];
	    return map;
	  }, {});
	}

	/**
	 * 根据 map.js 里的数组，给每个数组元素（也是数组）加上一个图片 url，并删掉第一个元素
	 *
	 * @param arr {Array} map.js 中的数组
	 * @param prefix {String} 类型，'ww' | 'xm' | 'wx'
	 *
	 * @return {Array}
	 */
	function toArrayWithURL(arr, prefix) {
	  return arr.map(function (item) {
	    var _item2 = _slicedToArray(item, 2),
	        code = _item2[0],
	        word = _item2[1];

	    var url = CDN_HOST + prefix + '/' + code + EXT_MAP[prefix];
	    return [word, url];
	  });
	}

	/**
	 * 将 url 转为 `img` 标签
	 *
	 * @param url {String} 表情图片 url
	 * @param text {String} 表情文字，例如 '[ww:微笑]' | '[微笑]'
	 *
	 * @return {String}
	 */
	function urlToImg(url, text) {
	  return '<img alt="' + text + '" src="' + url + '">';
	}

	/**
	 * 根据表情文字及其前缀获取其对应 url
	 * 如果支持 gif，那么返回 gif 的 url
	 *
	 * @param prefix {String} 前缀，表示类型，例如 'ww' | 'xm' | 'wx'
	 * @param word {String} 不戴带前缀的表情文字，例如 '微笑'
	 * @param size {String} 大小，可选 'small', 'large'
	 *
	 * @return {String}
	 */
	function getURL(prefix, word) {
	  var size = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 'small';

	  var map = SMILEY_MAP[prefix];
	  if (!map) return;

	  var url = map[word];
	  if (!url) return;

	  if (~GIF_SUPPORT_LIST.indexOf(prefix)) {
	    var ext = EXT_MAP[prefix].replace('.', '');
	    url = url.replace(new RegExp('\\.' + ext + '$'), GIF_EXT);
	  }

	  if (size === 'large' && ~LARGE_SUPPORT_LIST.indexOf(prefix)) {
	    url = url.replace(new RegExp('(' + prefix + '/\\d{3})'), '$1@2x');
	  }
	  return url;
	}

	/**
	 * 将文本中的所有表情文字转换为 `img` 标签
	 * ie. '[ww:微笑]' -> '<img alt="[ww:微笑]" src="xxx">'
	 *
	 * @param str {String} 输入文本
	 * @param size {String} 大小，可选 'small', 'large'
	 *
	 * @return {String}
	 */
	function toImage(str) {
	  var size = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'small';

	  var reg = /\[(\w{2}:)?([^\]]+)\]/gm;
	  if (!reg.test(str)) return str;
	  return toText(str).replace(reg, function (text) {
	    var prefix = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'ww';
	    var word = arguments[2];

	    prefix = prefix.replace(':', '');
	    var url = getURL(prefix, word, size);
	    return url ? urlToImg(url, text) : text;
	  });
	}

	/**
	 * 将文本中的所有表情 `img` 标签转换为文字
	 * ie. '<img alt="[ww:微笑]" src="xxx">' -> '[ww:微笑]'
	 *
	 * @param str {String} 输入文本
	 *
	 * @return {String}
	 */
	function toText(str) {
	  var reg = /<img alt=["'](\[(\w{2}:)?([^\]]+)\])["'][^>]+>/gm;
	  if (!reg.test(str)) return str;
	  return str.replace(reg, function (matched, text, prefix, word) {
	    return text;
	  });
	}

	var WANG_WANG = toArrayWithURL(_map.WW_SMILEY, 'ww');
	var XIAO_MI = toArrayWithURL(_map.XM_SMILEY, 'xm');
	var WAN_XIANG = toArrayWithURL(_map.WX_SMILEY, 'wx');

	module.exports = {
	  WANG_WANG: WANG_WANG,
	  XIAO_MI: XIAO_MI,
	  WAN_XIANG: WAN_XIANG,
	  toImage: toImage,
	  toText: toText
	};

/***/ },
/* 1 */
/***/ function(module, exports) {

	'use strict';

	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	/**
	 * 新版旺旺表情，数组标识展示顺序
	 *
	 */
	var WW_SMILEY = exports.WW_SMILEY = [['001', 'smile_emoji'],
    ['002', 'shy_emoji'],
    ['003', 'tongue_emoji'],
    ['047', 'sadness_emoji'],
    ['024', 'goodbye_emoji'],
    ['030', 'confused_emoji'],
    ['009', 'comfort_emoji'],
    ['008', 'air_kiss_emoji'],
    ['023', 'angel_emoji'],
    ['054', 'goodbye_with_tears_emoji'],
    ['005', 'love_emoji'],
    ['011', 'come_on_emoji'],
    ['040', 'giggle_emoji'],
    ['036', 'wronged_emoji'],
    ['048', 'aggrieved_emoji'],
    ['049', 'sob_emoji'],
    ['050', 'break_into_tears_emoji'],
    ['051', 'cry_emoji'],
    ['053', 'sorry_emoji'],
    ['070', 'waiter_emoji'],
    ['069', 'Kung_Hei_Fat_Choi_emoji'],
    ['067', 'Fortuna_emoji'],
    ['010', 'hug_emoji'],
    ['085', 'rose_emoji'],
    ['087', 'sweetheart_emoji'],
    ['078', 'beautiful_lady_emoji'],
    ['079', 'handsome_emoji'],
    ['012', 'victory_emoji'],
    ['081', 'deal_emoji'],
    ['082', 'applaud_emoji'],
    ['083', 'shake hands_emoji'],
    ['031', 'wondering_emoji'],
    ['042', 'helpless_emoji'],
    ['013', 'good_emoji'],
    ['007', 'dancing_emoji'],
    ['017', 'search_emoji'],
    ['026', 'enjoying_emoji'],
    ['004', 'snicker_emoji'],
    ['021', 'good_idea_emoji'],
    ['025', 'slobber_emoji'],
    ['016', 'toothy_laugh_emoji'],
    ['043', 'sweating_emoji'],
    ['028', 'transfixed_emoji'],
    ['055', 'frown_emoji'],
    ['037', 'shaking_head_emoji'],
    ['019', 'afterwards_emoji'],
    ['014', 'kiss_emoji'],
    ['015', 'anthomaniac_emoji'],
    ['018', 'calling_emoji'],
    ['029', 'thinking_emoji'],
    ['006', 'laughing_emoji'],
    ['035', 'shhh_emoji'],
    ['060', 'surprise_emoji'],
    ['061', 'consternation_emoji'],
    ['066', 'mad_emoji'],
    ['071', 'boss_emoji'],
    ['068', 'learn_from_Lei_Feng_emoji'],
    ['088', 'heart_breaking_emoji'],
    ['080', 'Lucky_Cat_emoji'],
    ['084', 'red_lips_emoji'],
    ['094', 'cheers_emoji'],
    ['089', 'money_emoji'],
    ['097', 'too_late_emoji'],
    ['091', 'gift_emoji'],
    ['090', 'shopping_emoji'],
    ['096', 'waiting_emoji'],
    ['095', 'clock_emoji'],];

	// 小二不可使用的表情
	var WW_BLACKLIST = exports.WW_BLACKLIST = [ ['020', 'miser_emoji'],
    ['022', 'grimace_emoji'],
    ['027', 'erotic_emoji'],
    ['032', 'no_money_emoji'],
    ['033', 'boring_emoji'],
    ['034', 'doubt_emoji'],
    ['038', 'cold_emoji'],
    ['039', 'awkward_emoji'],
    ['041', 'no_way_emoji'],
    ['044', 'desolate_emoji'],
    ['045', 'sleepy_emoji'],
    ['046', 'gosh_emoji'],
    ['052', 'I_give_up_emoji'],
    ['056', 'too_tired_emoji'],
    ['058', 'threw_up_emoji'],
    ['059', 'recite_emoji'],
    ['062', 'shut_up_emoji'],
    ['063', 'owe_flat_emoji'],
    ['064', 'despise_you_emoji'],
    ['065', 'furious_emoji'],
    ['072', 'evil_emoji'],
    ['073', 'solo_emoji'],
    ['074', 'CS_emoji'],
    ['075', 'invisible_man_emoji'],
    ['076', 'bomb_emoji'],
    ['077', 'screaming_emoji'],
    ['086', 'residual_flowers_emoji'],
    ['092', 'email_emoji'],
    ['093', 'phone_call_emoji'],
    ['098', 'airplane_emoji'],
    ['099', 'Alipay_emoji'],];

	/**
	 * 小蜜表情，数组标识展示顺序
	 *
	 */
	var XM_SMILEY = exports.XM_SMILEY = [['001', '打招呼'], ['002', '唱歌'], ['003', '打屁屁'], ['006', '开心'], ['007', '可怜'], ['010', '么么哒'], ['011', '帅'], ['012', '送花'], ['013', '微笑'], ['014', '委屈'], ['016', '再见'], ['017', 'OK']];

	// 小二不可使用的表情
	var XM_BLACKLIST = exports.XM_BLACKLIST = [['004', '愤怒'], ['005', '惊吓'], ['008', '抠鼻'], ['009', '冷漠'], ['015', '怨念']];

	/**
	 * 万象表情，数组标识展示顺序
	 *
	 */
	var WX_SMILEY = exports.WX_SMILEY = [['001', '开心极了'], ['002', '爱你哟'], ['003', '加油喔'], ['004', '厉害啦'], ['005', 'Goodbye'], ['006', '送你花'], ['007', '羞羞脸'], ['008', '桑心了'], ['009', '看我的'], ['010', '谢谢你'], ['011', '怎么破'], ['012', '交给我吧'], ['013', '燥起来'], ['014', '天啦噜'], ['015', 'OK'], ['016', '让我瞅瞅'], ['017', '么么哒'], ['018', '灵感来啦'], ['019', '给你点赞'], ['020', '好好学习'], ['021', '拼一拼'], ['022', '可怜兮兮'], ['023', 'Sorry啦'], ['024', '撒花咯']];

/***/ }
/******/ ])
});
;


// WEBPACK FOOTER //
// ./node_modules/_@ali_tarzan-smiley@0.0.8@@ali/tarzan-smiley/build/index.js